import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import {Location} from "@angular/common"
import _ from "lodash";
@Injectable({providedIn:'root'})
export class NavigationService {
  private history :string[] = []
constructor(private router:Router, private location:Location){
    this.history.length = 2
    this.router.events.subscribe((event)=>{
      if(event instanceof NavigationEnd){
        if(!event.urlAfterRedirects.includes('/search')){
          this.history.push(event.urlAfterRedirects)
          this.history = _.slice(this.history, 1)
        }
      }
    })
  }
  back(){
    if(this.history.length > 0){
    }
    else{
      this.router.navigateByUrl('/')
    }
  }
}
